import jwt_decode, { JwtPayload } from "jwt-decode";
import Role from "../../enums/authentication/role";

interface AuthenticationToken {
  token: string;
  passwordLess: boolean;
}

interface DecodedToken extends JwtPayload {
  Role?: Role;
  scope?: string[];
}

export const authTokenLocalStorageKey = "kemaro-userauthenticationtoken";
export const authTokenPasswordLessLocalStorageKey = "kemaro-userauthenticationtoken-passwordless";

export const getAuthTokenRole = (token: AuthenticationToken | string) => {
  const tokenString = typeof token === "string" ? token : token.token;
  try {
    const decodedToken = jwt_decode<DecodedToken>(tokenString);
    return decodedToken.Role;
  } catch (error) {
    localStorage.removeItem(authTokenLocalStorageKey);
    localStorage.removeItem(authTokenPasswordLessLocalStorageKey);
  }
};

export const isJwtTokenInvalidOrExpired = (token: AuthenticationToken | string): boolean => {
  const tokenString = typeof token === "string" ? token : token.token;
  try {
    const decodedToken = jwt_decode<DecodedToken>(tokenString);

    if (!decodedToken.exp) {
      return false;
    }

    return decodedToken.exp < Date.now() / 1000;
  } catch (error) {
    return true;
  }
};

export default AuthenticationToken;
